import React from 'react'
import type { CallToActionBlock as CTABlockProps } from '@/payload-types'
import { CMSLink } from '@/components'
import { isMedia } from '@/lib/utils'
import Image from 'next/image'

export function CallToActionBlock({
  title,
  lead,
  cover,
  links,
}: Readonly<CTABlockProps>): React.ReactNode {
  return (
    <section className="relative bg-accent border-t">
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col gap-4 items-center justify-center p-4 py-24">
        <h2 className="text-center text-4xl font-semibold">{title}</h2>
        <p className="text-center max-w-md">{lead}</p>
        {links ? (
          <ul className="flex flex-col gap-1 items-center justify-center">
            {links.map((item) => {
              return (
                <li key={item.id}>
                  <CMSLink className="flex md:inline-flex" {...item.link} />
                </li>
              )
            })}
          </ul>
        ) : null}
      </div>
      {cover && isMedia(cover) && cover.url ? (
        <figure className="absolute inset-0 overflow-hidden">
          <Image
            src={cover.url}
            alt={cover.alt ?? title}
            width={cover.width ?? 0}
            height={cover.height ?? 0}
            loading="eager"
          />
        </figure>
      ) : null}
    </section>
  )
}
